import React, { Component } from 'react';
import {BulkItemInstance} from "./BulkItemInstance";
import Table, {TableColumn} from "../../Table";
import DurableFunctionInstanceStatus from "../../DurableFunctionInstanceStatus";
import {TableRowProps} from "../../TableRow";
import {Dropdown, IDropdownOption} from "office-ui-fabric-react";
import _ from "lodash";
import TableCell from "../../TableCell";
import ComparisonCounts from "../../../models/mailroom/comparison/ComparisonCounts";



const titleCol = {
        title: "School",
        propertyPath: "input.schoolName",
        flex: 1
};

const processorCols = [
    {
        title: "Original Processor",
        propertyPath: "input.processorInstanceId",
        flex: 1
    },
    {
        title: "Validation Processor",
        propertyPath: "ParsedOutput.comparisonSummary.secondInstanceId",
        flex: 1
    }
];

const addedTotal = {
        title: "Added",
        propertyPath: "counts.addedCount",
        flex: 1
};

const removedTotal = {
        title: "Removed",
        propertyPath: "counts.removedCount",
        flex: 1
};
const changedTotal = {
        title: "Changes",
        propertyPath: "counts.changedCount",
        flex: 1
};

const addedGreen = {
    title: "Added Green",
    propertyPath: "counts.addedGreen",
    flex: 1
};

const addedRed = {
    title: "Added Red",
    propertyPath: "counts.addedRed",
    flex: 1
};

const removedGreen = {
    title: "Removed Green",
    propertyPath: "counts.removedGreen",
    flex: 1
};

const removedRed = {
    title: "Removed Red",
    propertyPath: "counts.removedRed",
    flex: 1
};

const changedGreen = {
    title: "Changed Green",
    propertyPath: "counts.changedGreen",
    flex: 1
};

const changedRed = {
    title: "Changed Red",
    propertyPath: "counts.changedRed",
    flex: 1
};

const changedRedToGreen = {
    title: "Changed Red To Green",
    propertyPath: "counts.changedRedToGreen",
    flex: 1
};

const changedGreenToRed = {
    title: "Changed Green To Red",
    propertyPath: "counts.changedGreenToRed",
    flex: 1
};

const totalCol = {
    title: "Total",
    propertyPath: "counts.total",
    flex: 1
};

const statusCols = [
    {
        title: "Error",
        propertyPath: "ParsedOutput.errorMessage",
        flex:1
    },
    {
        title: "Plan Error",
        propertyPath: "input.errorMessage",
        flex:1
    },
    {
        title: "Status",
        propertyPath: "status",
        flex:1
    }
]

enum Mode
{
    Standard = "Standard",
    Detailed = "Detailed",
    WithoutRed = "WithoutRed"
}

const columnsForMode = (mode: Mode) => {
    
    switch (mode)
    {
        case Mode.Standard:
            return [
                titleCol,
                ...processorCols,
                addedTotal,
                removedTotal,
                changedTotal,
                totalCol,
                ...statusCols
            ];
        case Mode.WithoutRed:
            return [
                titleCol,
                addedTotal,
                removedTotal,
                changedTotal,
                totalCol,
                ...statusCols
            ];
            
        case Mode.Detailed:
            return [
                titleCol,
                addedGreen, addedRed,
                removedGreen, removedRed,
                changedGreen,changedRed,changedGreenToRed,changedRedToGreen,
                totalCol,
                ...statusCols
            ];
    }
}

const countsForMode = (counts: ComparisonCounts,mode: Mode): ComparisonCounts => {
    
    if(mode === Mode.WithoutRed)
    {
        const added = counts.addedGreen;
        const removed = counts.removedGreen;
        const changed = counts.changedGreen + counts.changedGreenToRed + counts.changedRedToGreen;
        
        return {
            addedCount: added,
            removedCount: removed,
            changedCount: changed,
            total: added + removed + changed,
        } as ComparisonCounts;
    }
    else
    {
        return counts;
    }
    
};

interface BulkProcessorItemTableProps 
{
    bulkInstanceId: string;
    items: BulkItemInstance[];
}

interface BulkProcessorItemTableState {
    selectedMode: Mode;
    selectedProcessorItemType?: string;
}


export default class BulkProcessorItemTable extends Component<BulkProcessorItemTableProps, BulkProcessorItemTableState> {
    static displayName = BulkProcessorItemTable.name;

    constructor(props: BulkProcessorItemTableProps) {
        super(props);

        this.state = {
            selectedMode: Mode.Standard,
            selectedProcessorItemType: undefined
        };
    }
    
    private cellForColumn = (item: BulkItemInstance, column: TableColumn, columnIndex: number): JSX.Element | undefined => {

        
        if(column.propertyPath === "status")
        {
            return (
                <DurableFunctionInstanceStatus
                    durableFunctionInstance={item}
                    flex={column.flex}
                />
            );
        }
        
        const countsPrefix = "counts."
        if(column.propertyPath.startsWith(countsPrefix))
        {
            if(item.runtimeStatus !== "Completed" || !item.ParsedOutput?.comparisonSummary)
            {
                return (
                    <TableCell flex={column.flex}></TableCell>
                );
            }
            
            
            const propName = column.propertyPath.split(countsPrefix)[1];
            let counts: ComparisonCounts = item.ParsedOutput.comparisonSummary;
            if(this.state.selectedProcessorItemType !== undefined)
            {
                counts = item.ParsedOutput.comparisonSummary.breakdown.byProcessorItemType[this.state.selectedProcessorItemType!];
            }
            
            counts = countsForMode(counts,this.state.selectedMode);
            
            return (
                <TableCell flex={column.flex}>
                    <span>
                        {(counts as any)[propName]}
                    </span>
                </TableCell>
            )
        }

    }

    private rowPropsForItem = (item: BulkItemInstance): TableRowProps => {
        return {
            to: `/cdb-admin/mailroom/bulk-processor-comparison/${this.props.bulkInstanceId}/${item.durableFunctionInstanceId}`,
            enableRowLink: true
        };
    }
    
    private renderModeDropdown()
    {
        const options = Object.values(Mode).map(m => {
            return {
                text: m,
                key: m
            } as IDropdownOption;
        })
        return (
            <Dropdown label={"Column Mode"} selectedKey={this.state.selectedMode} options={options} onChange={(e,o) =>{this.setState({selectedMode: o?.key as Mode})}}/>
        );
    }
    
    private renderProcessorItemTypeDropdown()
    {
        let options: IDropdownOption[] = [];
        const completed = this.props.items.filter(x => x.runtimeStatus === "Completed");
        if(completed.length > 0)
        {
            options = _.keys(completed[0].ParsedOutput.comparisonSummary.breakdown.byProcessorItemType).filter(x => x !== "$type").map(processorItemType => {
                return {
                    key: processorItemType,
                    text: processorItemType,
                };
            });
        }
        
        return (
            <Dropdown label={"Processor Item Type"} options={options} onChange={(e,o) => this.setState({selectedProcessorItemType: o!.key as string})}/>
        );
    }
    
    render()
    {
        return (
            <Table
                columns={columnsForMode(this.state.selectedMode)}
                items={this.props.items}
                emptyMessage={"No items"}
                cellForColumn={this.cellForColumn}
                rowPropsForItem={this.rowPropsForItem}
            >
                {this.renderModeDropdown()}
                {this.renderProcessorItemTypeDropdown()}
                {this.props.children}
            </Table>
        );
    }
}